import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { styled } from '@noshiro/goober';
import { memoNamed } from '@noshiro/preact-utils';
import { MuiCard, MuiCardContent, MuiTypography } from '../mui';
export const WritingsElement = memoNamed('WritingsElement', ({ link, title, subtitle, body }) => (_jsx(CardStyled, { children: _jsxs(MuiCardContent, { children: [_jsx(MuiTypography, Object.assign({ variant: 'title' }, { children: _jsx("a", Object.assign({ href: link, rel: 'noopener noreferrer', target: '_blank' }, { children: title })) })), _jsx(MuiTypography, Object.assign({ variant: 'subtitle1' }, { children: subtitle })), _jsx(MuiTypography, Object.assign({ variant: 'body1' }, { children: body }))] }) })));
const CardStyled = styled(MuiCard) `
  margin: 10px;
`;
